import { useContext } from "react";
import PropTypes from "prop-types";

// context
import AuthContext from "src/contexts/auth/AuthContext";

// components
import Error405Page from "src/pages/405";

const AdminGuard = ({ children }) => {
  const { isAuthenticated, isAdmin } = useContext(AuthContext);

  if (!isAuthenticated || !isAdmin) return null;

  if (isAuthenticated && !isAdmin) return <Error405Page />;

  return <>{children}</>;
};

AdminGuard.propTypes = {
  children: PropTypes.node,
};

export default AdminGuard;
